// @flow
import * as React from "react"
import {throws} from "@swarm2/assert"
import {containers} from "@swarm2/core"
import * as Util from "../common"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"
import SubmitIcon from "material-ui/svg-icons/file/folder-shared"
import {Tabs, Tab} from "material-ui/Tabs"
import TextField from "material-ui/TextField"
import {CardText, CardActions} from "material-ui/Card"
import Button from "material-ui/RaisedButton"
import {Redirect} from "react-router"

const M = Util.intlMessages("view.NewCharacter")
const LM = Util.intlMessages("leagues")

const leagueDescriptions = {
  standard() {
    return (
      <p>
        <M id={"field.league.standard.description"} />
      </p>
    )
  },
  overlord() {
    return (
      <p>
        <M id={"field.league.overlord.description"} />
        <ul>
          <li>
            <M id={"field.league.overlord.bullet1"} />
          </li>
          <li>
            <M id={"field.league.overlord.bullet2"} />
          </li>
        </ul>
        <M id={"field.league.templeagues.description"} />
      </p>
    )
  },
  prerelease() {
    return (
      <p>
        <M id={"field.league.prerelease.description"} />
      </p>
    )
  },
}
function LeagueDescRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {descName, isOpen, untilOpen} = props
  const E = leagueDescriptions[descName]
  if (!E) return throws("no such league-description", descName)
  return (
    <div>
      <E />
      {isOpen ? null : (
        <p>
          <i>
            <M
              id="field.league.countdown"
              values={{countdown: <Util.Duration millis={untilOpen} />}}
            />
          </i>
        </p>
      )}
    </div>
  )
}
const LeagueDesc = containers.characters.NewCharacterLeague(LeagueDescRender)

function NewCharacterRender(props) {
  if (props.isError) return <Util.Error error={props} />
  const {
    input,
    isCharLimit,
    isLeagueOpen,
    displayName,
    league,
    leagues,
    request,
  } = props
  if (request.status === "success")
    return <Redirect push to={"/p/" + request.result.params.charId} />
  const isSubmitAllowed = isLeagueOpen
  const submit = e => {
    if (isSubmitAllowed) props.create(e, {displayName, league})
    e.preventDefault()
    return false
  }
  if (isCharLimit) return <M id={"error.isCharLimit"} />
  return (
    <div>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" />} />
        </ToolbarGroup>
      </Toolbar>
      <form onSubmit={submit}>
        <CardText>
          <div>
            <TextField
              name="displayName"
              floatingLabelText={<M id="field.displayName" />}
              type="text"
              value={props.displayName}
              onChange={input.setDisplayName}
            />
          </div>
          <Tabs
            value={props.league}
            onChange={league => league && props.setLeague(league)}
          >
            {/* <Tabs> insists that its immediate children are all <Tab>s, so
                it can't move into <LeagueDesc> */}
            {leagues.map(league => {
              // leagues named prerelease-XXX all have the same description
              const descName = league.split("-")[0]
              return (
                <Tab key={league} value={league} label={<LM id={descName} />}>
                  <LeagueDesc league={league} descName={descName} />
                </Tab>
              )
            })}
            {leagues.length < 2 ? (
              <Tab value={null} label={<M id={"field.league.comingsoon"} />} />
            ) : null}
          </Tabs>
        </CardText>
        <CardActions>
          <Button
            primary
            label={<M id="submit" />}
            type="submit"
            icon={<SubmitIcon />}
            disabled={!isSubmitAllowed}
          />
        </CardActions>
      </form>
    </div>
  )
}
export default containers.characters.NewCharacter(
  Util.DumpProps(NewCharacterRender),
)



// WEBPACK FOOTER //
// ./src/characters/NewCharacter.js